var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiGemIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 68,
    viewBox: "10 4 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2584_27402)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_2584_27402_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-8.74228e-10 -0.02 0.02 -8.74228e-10 36 28)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1050,
    y: -1050,
    width: 2100,
    height: 2100
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(232, 231, 228, 1) 0deg,rgba(239, 119, 178, 1) 64.0385deg,rgba(163, 220, 255, 1) 129.808deg,rgba(74, 207, 186, 1) 218.077deg,rgba(11, 119, 226, 1) 297.692deg,rgba(232, 231, 228, 1) 359.964deg,rgba(232, 231, 228, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.384 46.5979L54.5977 31.3836C56.4674 29.5141 56.4674 26.4859 54.5977 24.6164L39.384 9.40213C37.5143 7.53263 34.4857 7.53263 32.616 9.40213L17.4023 24.6164C15.5326 26.4859 15.5326 29.5141 17.4023 31.3836L32.616 46.5979C34.4857 48.4674 37.5143 48.4674 39.384 46.5979Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.90980392694473267,\"g\":0.90588235855102539,\"b\":0.89411765336990356,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.93999999761581421,\"g\":0.46999999880790710,\"b\":0.69917351007461548,\"a\":1.0},\"position\":0.17788460850715637},{\"color\":{\"r\":0.63921570777893066,\"g\":0.86274510622024536,\"b\":1.0,\"a\":1.0},\"position\":0.36057692766189575},{\"color\":{\"r\":0.29022464156150818,\"g\":0.81229341030120850,\"b\":0.73284816741943359,\"a\":1.0},\"position\":0.60576921701431274},{\"color\":{\"r\":0.045379865914583206,\"g\":0.46753290295600891,\"b\":0.88968598842620850,\"a\":1.0},\"position\":0.82692307233810425},{\"color\":{\"r\":0.90980392694473267,\"g\":0.90588235855102539,\"b\":0.89411765336990356,\"a\":1.0},\"position\":0.99989998340606689}],\"stopsVar\":[{\"color\":{\"r\":0.90980392694473267,\"g\":0.90588235855102539,\"b\":0.89411765336990356,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.93999999761581421,\"g\":0.46999999880790710,\"b\":0.69917351007461548,\"a\":1.0},\"position\":0.17788460850715637},{\"color\":{\"r\":0.63921570777893066,\"g\":0.86274510622024536,\"b\":1.0,\"a\":1.0},\"position\":0.36057692766189575},{\"color\":{\"r\":0.29022464156150818,\"g\":0.81229341030120850,\"b\":0.73284816741943359,\"a\":1.0},\"position\":0.60576921701431274},{\"color\":{\"r\":0.045379865914583206,\"g\":0.46753290295600891,\"b\":0.88968598842620850,\"a\":1.0},\"position\":0.82692307233810425},{\"color\":{\"r\":0.90980392694473267,\"g\":0.90588235855102539,\"b\":0.89411765336990356,\"a\":1.0},\"position\":0.99989998340606689}],\"transform\":{\"m00\":-1.7484555883129360e-06,\"m01\":40.0,\"m02\":16.0,\"m10\":-40.0,\"m11\":-1.7484555883129360e-06,\"m12\":48.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2584_27402",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.396078 0 0 0 0 0.470588 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2584_27402"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.305882 0 0 0 0 0.384314 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2584_27402",
    result: "effect2_dropShadow_2584_27402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2584_27402",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_2584_27402_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.384 46.5979L54.5977 31.3836C56.4674 29.5141 56.4674 26.4859 54.5977 24.6164L39.384 9.40213C37.5143 7.53263 34.4857 7.53263 32.616 9.40213L17.4023 24.6164C15.5326 26.4859 15.5326 29.5141 17.4023 31.3836L32.616 46.5979C34.4857 48.4674 37.5143 48.4674 39.384 46.5979Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGemIcon);
export default __webpack_public_path__ + "static/media/ai-gem-icon.1bc2f7fd57d16648664feb1e00a33b53.svg";
export { ForwardRef as ReactComponent };